import { LKDate } from 'loankeeper-common/helpers/Date'

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_tags',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    TagDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },
  },
}

export default config
